import { useState } from "react";
import {
  Select,
  MenuItem,
  TextField,
  Button,
  Grid,
  Typography,
  Box,
} from "@mui/material";

const DemandNote = () => {
  const [provider, setProvider] = useState("TPDDL");
  const [customerMob, setCustomerMob] = useState("");
  const [notificationNo, setNotificationNo] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");

  const handleSubmit = () => {
    console.log({ provider, customerMob, notificationNo, email, amount });
  };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#e0f0f1",
        border: "2px solid rgb(252, 216, 162)",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={8} md={6} lg={5}>
          <Box
            sx={{
              p: 4,
              borderRadius: 4,
              bgcolor: "white",
              textAlign: "center",
            }}
          >
            <Typography variant="h5" gutterBottom fontWeight={600} color="#00796b">
              Demand Note Payment
            </Typography>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Typography variant="subtitle1" fontWeight={500} color="#00796b">
                  Select Provider
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Select fullWidth value={provider} displayEmpty variant="outlined" disabled>
                  <MenuItem value="TPDDL">TPDDL Only</MenuItem>
                </Select>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Enter Customer Mob No*"
                  variant="outlined"
                  value={customerMob}
                  onChange={(e) => setCustomerMob(e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Enter Notification No/ Request No/ Demand Note Instalment No*"
                  variant="outlined"
                  value={notificationNo}
                  onChange={(e) => setNotificationNo(e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email ID (Optional)"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Enter Amount*"
                  variant="outlined"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12} textAlign="center">
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    py: 1.5,
                    fontSize: "1rem",
                    fontWeight: 600,
                    bgcolor: "#00796b",
                    "&:hover": { bgcolor: "#004d40" },
                  }}
                  onClick={handleSubmit}
                  disabled={!customerMob || !notificationNo || !amount}
                >
                  Pay Now
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DemandNote;
